var Access = {

    // Константы доступов
    NO_ACCESS        : 0,
    FULL_ACCESS      : 0xFFFF,
    // Маски доступов
    BIT_READ        : 1 << 0, //       1
    BIT_EDIT        : 1 << 1, //      10
    BIT_CHILD_READ  : 1 << 2, //     100
    BIT_CHILD_EDIT  : 1 << 3, //    1000
    BIT_CHILD_APPEND: 1 << 4, //   10000
    BIT_STRUCT_READ : 1 << 5, //  100000
    BIT_STRUCT_EDIT : 1 << 6,  // 1000000

    setAccess: function(access, mask, value){
        "use strict";

        if (value) {
            access |= mask;
        } else {
            access &= ~mask;
        }

        return access;
    },

    hasAccess: function (access, mask, value) {
        "use strict";
        var val;

        if(value == undefined){
            value = true;
        }

        val = Boolean(value);

        return ((access & mask) == mask) == val;
    },

    hasAnyAccess: function(access, mask){
        "use strict";

        return Boolean((access & mask) > 0);
    },

    // mixin: {
    //     accessAttribute: 'access',

    //     getAccessValue: function () {
    //         "use strict";
    //         return this.get(this.accessAttribute);
    //     },

    //     setAccessValue: function (access) {
    //         "use strict";
    //         return this.set(this.accessAttribute, access);
    //     },

    //     setAccess: function (mask, value) {
    //         "use strict";
    //         var that   = this;
    //         var access = that.getAccessValue();
    //         that.setAccessValue(Access.setAccess(access, mask, value));
    //         return that;
    //     },

    //     hasAccess: function (mask, value) {
    //         "use strict";
    //         var that   = this;
    //         var access = that.getAccessValue();
    //         return Access.hasAccess(access, mask, value)
    //     },

    //     hasAnyAccess: function(mask){
    //         "use strict";
    //         var that = this;
    //         var access = that.getAccessValue();
    //         return Access.hasAnyAccess(access, mask)
    //     },
    // }
};

module.exports = Access;


//////////////////
// WEBPACK FOOTER
// ./src/~/Access.js
// module id = 9
// module chunks = 0